// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RobotOutlinedSvg from "@ant-design/icons-svg/es/asn/RobotOutlined";
import AntdIcon from '../components/AntdIcon';

var RobotOutlined = function RobotOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RobotOutlinedSvg
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
export default React.forwardRef(RobotOutlined);